/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DisplayPeriod
 */
export interface DisplayPeriod {
    /**
     * 
     * @type {Date}
     * @memberof DisplayPeriod
     */
    displayFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DisplayPeriod
     */
    displayUntil?: Date;
}

/**
 * Check if a given object implements the DisplayPeriod interface.
 */
export function instanceOfDisplayPeriod(value: object): value is DisplayPeriod {
    return true;
}

export function DisplayPeriodFromJSON(json: any): DisplayPeriod {
    return DisplayPeriodFromJSONTyped(json, false);
}

export function DisplayPeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisplayPeriod {
    if (json == null) {
        return json;
    }
    return {
        
        'displayFrom': json['displayFrom'] == null ? undefined : (new Date(json['displayFrom'])),
        'displayUntil': json['displayUntil'] == null ? undefined : (new Date(json['displayUntil'])),
    };
}

export function DisplayPeriodToJSON(json: any): DisplayPeriod {
    return DisplayPeriodToJSONTyped(json, false);
}

export function DisplayPeriodToJSONTyped(value?: DisplayPeriod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'displayFrom': value['displayFrom'] == null ? value['displayFrom'] : value['displayFrom'].toISOString(),
        'displayUntil': value['displayUntil'] == null ? value['displayUntil'] : value['displayUntil'].toISOString(),
    };
}

